interface Props {
  label: string
  isCurrentCurriculum?: boolean
  isLight?: boolean
  onClick?: () => void
}

/** A single US standard row inside the USA group of the curriculum dropdown. */
export default function CurriculumStateItem({
  label,
  isCurrentCurriculum,
  isLight,
  onClick,
}: Props): React.ReactElement {
  const labelColorClassName = isCurrentCurriculum
    ? isLight
      ? 'font-semibold text-orange-dark'
      : 'text-orange-light'
    : isLight
    ? 'text-gray-davy'
    : 'text-white-strong'
  return (
    <button
      aria-current={isCurrentCurriculum}
      aria-label={label}
      className={`w-full flex items-center justify-between py-2.75 pl-6 pr-3.5 text-start ${
        isCurrentCurriculum ? 'bg-orange-faint' : ''
      } ${
        isCurrentCurriculum
          ? 'cursor-default'
          : `cursor-pointer ${isLight ? 'hover:bg-gray-light' : 'hover:bg-white-faint'}`
      }`}
      disabled={isCurrentCurriculum}
      onClick={isCurrentCurriculum ? undefined : onClick}
      role="option"
      type="button"
    >
      <span className={`min-w-0 truncate text-xs ${labelColorClassName}`}>{label}</span>
    </button>
  )
}
